/**
* In Add Physician function is used to add or create new Physician details and it's functions declare this file
**/
import { Link,useNavigate,useLocation } from 'react-router-dom';
import { useState, useEffect} from 'react';
import * as Yup from 'yup';
import { validate } from '../../services/ValidationService';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import ApiService from '../../services/ApiService';
import ImageCroper from '../../shared/modals/ImageCroper'
import SelectedPrescriptionTemplate from '../../shared/modals/SelectedPrescriptionTemplate';
import { goBack,filterGeoLocation,dataURItoBlob,generateRandomId } from '../../services/UtilsService';
import { toast } from 'react-toastify';
import Autocomplete from 'react-google-autocomplete';
import NavigationModal from '../../shared/modals/NavigationModal';
import { useTranslation } from 'react-i18next';
import { Modal,Button } from 'react-bootstrap';

function AddPhysician(){
	//Initial state declaration
	const [data,setData]=useState({});
	const [error,setError]=useState({});
	const [isValid,setIsValid]=useState(true);
	const navigate = useNavigate();
	const [show,setShow]=useState(false);
	const [image, setImage] = useState('');
	const [cropImge, setCropImage] = useState();
	const role = Number(localStorage.getItem('role'));
	const [showModal, setShowModal] = useState(false);  // State for navigation modal visibility
	const [dynamicId, setDynamicId] = useState(null);  // State for navigation id
	const [modalMessage, setModalMessage] = useState('');  // State for navigation modal message
	const location = useLocation();
    const { id } = location.state || {};  // Retrieve hospitalId from state
	const [organization, setOrganization] = useState(null);
	const { t } = useTranslation();
	const [modal,setModal]=useState({});

    useEffect(() => {
        const fetchData = async () => {
            if (id) {
                try {
                    const response = await ApiService.getOrganization(id);
					setOrganization(response.data.hospitalInfo);
                } catch (error) {
                    console.error('Error fetching physician:', error);
                }
            }
        };
        fetchData();
    }, [id]);
	const renderField = (label, value) => (
		<div className="mb-3">
		  <strong>{label}: </strong>
		  <span>{value || '--'}</span>
		</div>
	  );
	//callback function
	const handleClose = () => {
		setShow(false);
		// Reset the file input value
		const fileInput = document.getElementById('file-5');
		if (fileInput) {
		  fileInput.value = ""; // Clear the file input so the same file can be selected again
		}
	  };
	const imageData= (data)=> setCropImage(data)
	
	//validate patterns
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	
	/** 
	* Validation schema for Physician Fields
	* @first_name - required field and pass the physician first_name
	* @last_name - required field and pass the physician last_name
	* @email - required field and should be in correct physician email format 
	* @mobileNumber - required field and pass the physician mobileNumber
	* @specialist - required field and pass the physician specialist
	* @department - required field and pass the physician department
	* @city - required field and pass the physician city 
	* @state - required field and pass the physician state 
	* @gender - required field and pass the physician gender 
	* @zipcode - required field and pass the physician zipcode
	**/
   const fields = [
    { name: 'first_name', validation: Yup.string().trim().required(t('error.required')) },
    { name: 'last_name', validation: Yup.string().trim().required(t('error.required')) },
	{ 
	name: 'email', 
	validation: Yup.string()
		.email(t('error.email')) // built-in email validation
		.required(t('error.emailRequired')) 
	},
	{ name: 'mobileNumber', validation: Yup.string()},
	{ name: 'specialist', validation: Yup.string().required(t('error.required'))},
	// { name: 'department', validation: Yup.string().required()},
	{ name: 'city', validation: Yup.string()},
	{ name: 'gender', validation: Yup.string()},
	{ name: 'state', validation: Yup.string()},
	{
	name: 'zipcode',
	validation: Yup.string()
		.nullable() // Allows the field to be nullable
		.matches(/^[a-zA-Z0-9]+$/,t('error.zipcodeAlpha')) // Allows empty or valid number format
	//   .test('len', constantVariables.error.zipcode, function (value) {
	// 	return !value || value.length >= 5; // Only check length if value is not empty
	//   })
	},
	{
		name: 'register_number',
		validation: Yup.string().nullable()
	},
   ];
   
   /** 
   * To handle input change event 
   * @e - we get the event details from the Change action
   **/
   const handleChange=async(e)=>{
	   const {name,value}=e.target;
	   e.preventDefault();
	   setData({...data,[name]:value});
	   const Errors=await validate({[name]:value},fields);
	   setError({...error,[name]:Errors[name]});
   }
   

  /** 
  * To check phone number valid or not 
  * @value - we pass the actual phone number
  * @country - we pass the countryCode
  * @e - we get the event details from the onChange action
  * @formattedValue - we pass the country formatted Value
  **/
   const handlePhone=async (value,country,e,formattedValue)=>{
	   const {format, dialCode} = country;
		setData({...data,[e.target.name]:formattedValue.split("+"+dialCode+" ")[1],countryCode:'+'+dialCode,countryNameCode:country?.countryCode});
      const Errors = await validate({ [e.target.name]: formattedValue }, fields);
      setError({...error,[e.target.name]:Errors[e.target.name]});
      if (!formattedValue || (format?.length === formattedValue?.length && (value.startsWith(dialCode) || dialCode.startsWith(value)))) {
	       setIsValid(true);
	  }else{
		   setIsValid(false);
	  }
   }
   
    // Function to handle mapping logic for hospital and physician only when id is present
	const handleMapping = async (physicianId) => {
		let mappedData = {};
		let uniqueID = generateRandomId();
		// Prepare mapped data
		mappedData.physicianInfo = data;
		mappedData.physicianInfo.account = physicianId;
		mappedData.hospitalInfo = [
			{
				id: uniqueID,
				hospital: organization?.id,
				physician: physicianId,
				hospital_name: organization?.name,
			}
		];
		mappedData.parentInfo = [
			{
				physician: physicianId,
				hospital: organization?.id,
			}
		];
		// Call the physician mapping API
		var response = await ApiService.physicianMapping(mappedData);
	};

   /** 
   * To handle the form submit event 
   * @e - we get the event details from the form submit action
   **/	
  const handleSubmit=async(e)=>{
	  e.preventDefault();
	  data.gender=(data.gender || data.gender===0 || data.gender===1 ) ? data.gender:'';
	  data.mobileNumber=data.mobileNumber||'';
	  data.city=data.city||'';
	  data.state=data.state||'';
	  data.zipcode=data.zipcode|| null;
	  data.register_number=data.register_number || null;
		// Get prescription_template from localStorage
		const selectedTemplate = localStorage.getItem('selectedPrescriptionTemplate');
		data.prescription_template = selectedTemplate || null;
	  const Errors=await validate(data,fields)
	  setError(Errors);
		if(!Object.keys(Errors).length && isValid){
			data.gender=(data.gender || data.gender===0 || data.gender===1 ) && data.gender!==''  ? data.gender:null;
			  var response = await ApiService.createPhysician(data);
			if(response.status===200){
				if(id){
					await handleMapping(response?.data?.userId);
				}
				localStorage.setItem('selectedPrescriptionTemplate',null)
			  toast.success(response?.data?.message);
			  if (cropImge !== undefined) {
				  const formData = new FormData();
				  const fileConvertData =await dataURItoBlob(cropImge);
				  formData.append('file', fileConvertData);
				   await ApiService.uploadNewPhoto(response?.data?.userId,formData);
			  }
				 // Set dynamic ID and message for modal
				  await setDynamicId(response?.data?.userId);  // Assuming the physician ID is in the response
				  if (role === 4) {
					await setModalMessage(t('modal.mapWorkAndParToPhysician'));
				  } else {
					await setModalMessage(t('modal.mapHosAndParToPhysician'));
				  }
				  await setShowModal(true); // Show modal after success
			}else{
				toast.error(response?.data?.message||'Something went wrong');
			}
		}
  };
  
 
  /** 
  * To handle the image change
  * @e - we get the event details from the input file select action
  **/
  const handleFile=async (e)=>{
	  e.preventDefault();
	  const file = e.target.files[0];
	  openCropModal(file);

  }
  
  /** 
  * To open the image crop modal
  * @file - we pass the image details in the base 64 bit format
  **/
  const openCropModal=async(file)=>{
	  
	  if(file){
		 let ext = file.name.split('.').pop();
		 let allowedExtensions = ['jpg', 'jpeg', 'png', 'JPEG'];
		 if (!allowedExtensions.includes(ext)) {
				toast.error(t('error.fileFormat'));
				await setShow(false);
				 return;
			}
		if (file.size > 100 * 1024 * 1024) {
			toast.error(t('error.fileSize'));
				await setShow(false);
				 return;
		}
		 const reader = new FileReader();
		 reader.onload = () => { setImage(reader.result) };
		 reader.readAsDataURL(file);
		 await setShow(true);
	 }else{
		 await setShow(false);
	 }
  }
  
  /** 
  * To handle event drag
  * @e - we get the event details from the drag over action
  **/
  const handleDrag=(e)=>{
	  e.preventDefault();
  }
  
  /** 
  * To handle event drop
  * @e - we get the event details from the drop over action
  **/
  const handleDrop=(e)=>{
	  e.preventDefault();
	   const { files } = e.dataTransfer;
	   openCropModal(files[0]);
  }
  
  /** 
  * To change city input 
  * @e - we get the event details form the change action
  **/
  const changeCity=async(e)=>{
         const { value }=e.target;
		 var obj={};
		 if(value.trim().length ===0){
			 obj={city:'',state:''};
		 }else{
		     obj={city:value};
		 }
		 setData((data)=>({...data,...obj}));
		 const Errors = await validate({ city:value }, fields);
	     setError({...error,city:Errors['city']});
  }
  
  /** 
  * To select city input 
  * @e - we get the event details from the Select action
  **/
  const selectCity=async(e)=>{ 
	     var location= await filterGeoLocation(e);
		   await setData((data)=>({...data,...location}));
  }
   
  // Handle user confirmation actions for navigation based on role and dynamic ID.
  const handleYes = () => {
    setShowModal(false);
	if(role === 3){
		navigate(`/admin/edit-physician/${dynamicId}`);
	}else {
		navigate(`/hospital/admin/edit-physician/${dynamicId}`);
	}  
  };
  const handleNo = () => {
    setShowModal(false);
    if(role === 3){
		navigate('/admin/physician');  
	}else {
		navigate('/hospital/admin/physician');  
	}  
  };

  	//To handle prescription template selection
	const handlePrescriptionTemplateClick = () => {
		setModal({showPrescriptionTemplate: true});
	};

	//To handle prescription template selection callback
	const handleTemplateSelect = async (selectedTemplate) => {
		console.log('Selected template:', selectedTemplate);
		try {
			const res = await ApiService.updatePrescriptionTemplate({prescription_template: selectedTemplate});
			if (res.status === 200) {
				toast.success(res?.data?.message)
			}
		} catch (error) {
			console.error("Failed to update template", error);
		}
	};

	//To close modal
	const handleCloseTemplate=()=>setModal({});
	return(
	<main id="main" className="main">
	{/*import ImageCroper*/}
	<ImageCroper 
		show={show} 
		handleClose={handleClose}
		image={image}
		cropImge={imageData}
	/>
	{/* Modal for navigation */}
	<NavigationModal
        show={showModal}
        onHide={() => setShowModal(false)}
        message={modalMessage}
        onYes={handleYes}
        onNo={handleNo}
      />
	{/*Import SelectedPrescriptionTemplate Modal*/}
	{Object.keys(modal).length !==0 && modal.showPrescriptionTemplate && 
		<SelectedPrescriptionTemplate 
			data={modal} 
			handleClose={handleCloseTemplate} 
			onTemplateSelect={handleTemplateSelect}
			physicianData={data}  // Pass current physician form data
			organizationData={organization}  // Pass organization data
		/>
	}
	{/*Page Title Section*/}
	<div className="pagetitle clearfix">
		<div className="float-start">
		  <h1>{t('profile.addPhysicianInfo')}</h1>
			<nav>
				<ol className="breadcrumb">
				  <li className="breadcrumb-item"><Link to="/admin/dashboard">{t('sidebar.home')}</Link></li>
				  <li className="breadcrumb-item"><Link to="/admin/physician">{t('sidebar.physician')}</Link></li>
				  <li className="breadcrumb-item active">{t('profile.addPhysicianInfo')}</li>
				</ol>
			</nav>
		</div>
		<div className="float-end mt-2 me-1">
			<span onClick={goBack} className="backIcon"><i className="iconly-Bold-ArrowLeftSquare"></i></span>
		</div>
	</div>
	{/*End Page Title Section*/}
	
	{/*Page Content Section*/}	
	<section>
	<div className="row">
		{/*ProfileImg*/}
		<div className="col-xxl-4">
			<div className="card profile-img">
				<div className="card-body">
					<div className="upload-box d-none d-lg-block">		
						<div className="box text-center" onDrop = {handleDrop} onDragOver = {handleDrag}>
							<input type="file" onChange={handleFile} name="file-5" id="file-5" className="inputfile inputfile-4"  />
							<label htmlFor="file-5">
							{cropImge?(<img  className="img-fluid d-block mx-auto" src={cropImge} alt="lo" />):(<img  className="img-fluid d-block mx-auto" src="/assets/img/logo-img.png" alt="lo" />)}
								<span>{t('common.editChange')} <br /> ({t('common.dragDrop')})</span>
							</label>
						</div>
					</div>
					<div className={`text-center ${role === 4 ? 'text-tmAquaGreen' : 'text-tmBlue'} mt-4`}>
						<h6>{t('profile.uploadPicture')}</h6>
					</div>
				</div>
			</div>
		</div>
		
		{/*Physician Info*/}
		<div className="col-xxl-8">
			<div className={`card form-card profile-info ${role === 4 ? 'admin-profile-info' : ''}`}>
				<div className="card-body pt-4">
					{id && (<><ul className="nav nav-pills nav-fill mb-4" id="pills-tab" role="tablist">
					  <li className="nav-item" role="presentation">
						<a className="nav-link active" id="pills-01-tab" data-bs-toggle="pill" href="#!pills-01" type="button" role="tab" aria-controls="pills-01" aria-selected="true">{t('profile.hospitalInfo')}</a>
					  </li>
					</ul>
					<div className="organization-details ms-2">
						<div className="row">
							{/* Left Side */}
							<div className="col-md-6">
							{renderField('Organisation Name', organization?.name)}
							{renderField('Organisation Website', organization?.website)}
							</div>
							{/* Right Side */}
							<div className="col-md-6">
							{renderField('Phone', organization?.mobileNumberWithCode)}
							{renderField('Email', organization?.email)}
							</div>
						</div>
					</div>
					</>)}
					<ul className="nav nav-pills nav-fill mb-4" id="pills-tab" role="tablist">
					  <li className="nav-item" role="presentation">
						<a className="nav-link active" id="pills-01-tab" data-bs-toggle="pill" href="#!pills-01" type="button" role="tab" aria-controls="pills-01" aria-selected="true">{t('profile.physicianInfo')}</a>
					  </li>
					</ul>
					<div className="tab-content" id="pills-tabContent">
						<div className="tab-pane fade active show" id="pills-01" role="tabpanel" aria-labelledby="pills-01-tab">
							{/* Form Section */}
							<form autoComplete="off">
								<div className="row">
									<div className="col-lg-4 col-md-6">
										<div className=" form-group">
											<label> {t('profile.firstName')} </label>
											<input type="text" onChange={handleChange}  value={data.first_name?data.first_name:''} name="first_name" className="form-control" placeholder={t('profile.firstName')} />
											{error && error.first_name && <span className="required">{error.first_name}</span>}
										</div>
									</div>
									<div className="col-lg-4 col-md-6">
										<div className=" form-group">
											<label> {t('profile.lastName')} </label>
											<input type="text" onChange={handleChange}  value={data.last_name?data.last_name:''} name="last_name" className="form-control" placeholder={t('profile.lastName')} />
											{error && error.last_name && <span className="required">{error.last_name}</span>}
										</div>
									</div>
									<div className="col-lg-4 col-md-6">
										<div className=" form-group">
											<label>{t('profile.specialty')}</label>
											<input onChange={handleChange}  value={data.specialist?data.specialist:''} name="specialist" type="text" className="form-control" placeholder={t('common.enterSpecialty')}  />
											{error && error.specialist && <span className="required">{error.specialist}</span>}
										</div>
									</div>
									{/* <div className="col-lg-6 col-md-6">
										<div className=" form-group">
											<label>{constantVariables.profile.department}</label>
											<input onChange={handleChange}  value={data.department?data.department:''} name="department" type="text" className="form-control" placeholder="Enter The department"  />
											{error && error.department && <span className="required">{error.department}</span>}
										</div>
									</div> */}
									<div className="col-lg-6 col-md-6">
										<div className=" form-group">
											<label>{t('profile.phoneNumber')}</label>
											<PhoneInput
												  inputProps={{
                                                  name: 'mobileNumber',
												  style: { width: '100%'}}}
												  country={'us'}
                                                   onChange={handlePhone}
												/>
												{error && error.mobileNumber && <span className="required">{error.mobileNumber}</span>}
												{!isValid && !error.mobileNumber && <span className="required">{t('common.validNumber')}</span>}
										</div>
									</div>
									<div className="col-lg-6 col-md-6">
										<div className=" form-group">
											<label>{t('profile.emailAddress')}</label>
											<input onChange={handleChange}  value={data.email?data.email:''} name="email" type="text" className="form-control" placeholder="youremail@mail.com" />
											{error && error.email && <span className="required">{error.email}</span>}
										</div>
									</div>									
									<div className="col-lg-6 col-md-6">
										<div className=" form-group">
											<label>{t('profile.gender')}</label>
											<select name="gender" value={data?.gender?data.gender:''} onChange={handleChange} className="form-select">
											<option value='' disabled>{t('profile.selectGender')}</option>
											<option value="0" >{t('profile.male')}</option>
											<option value="1" >{t('profile.female')}</option>
											</select>
											{error && error.gender && <span className="required">{error.gender}</span>}
										</div>
									</div>
									<div className="col-lg-6 col-md-6">
										<div className=" form-group">
											<label>{t('profile.addressOne')}</label>
											<input onChange={handleChange}  value={data.address_one?data.address_one:''} name="address_one" type="text" className="form-control" placeholder={t('common.addressLine1')}  />
											{error && error.address_one && <span className="required">{error.address_one}</span>}
										</div>
									</div>
									<div className="col-lg-6 col-md-6">
										<div className=" form-group">
											<label>{t('profile.addressTwo')}</label>
											<input onChange={handleChange}  value={data.address_two?data.address_two:''} name="address_two" type="text" className="form-control"  placeholder={t('common.addressLine2')} />
											{error && error.address_two && <span className="required">{error.address_two}</span>}
										</div>
									</div>
									<div className="col-lg-6 col-md-6">
										<div className=" form-group">
											<label>{t('profile.city')} </label>
											<Autocomplete
											value={data?.city?data.city:''}
											className="form-control" 
											placeholder={t('common.city')}  
											onChange={changeCity}
											 onPlaceSelected={selectCity}
											types={['(cities)']}		
											/>
											{error && error.city && <span className="required">{error.city}</span>}
										</div>
									</div>
									<div className="col-lg-6 col-md-6">
										<div className=" form-group">
											<label>{t('profile.state')} </label>
											<input onChange={handleChange} readOnly  value={data.state?data.state:''} name="state" type="text" className="form-control" placeholder={t('common.state')} />
											{error && error.state && !data.state && <span className="required">{error.state}</span>}
										</div>
									</div>
									<div className="col-lg-6 col-md-6">
										<div className=" form-group">
											<label>{t('profile.zipCode')} </label>
											<input onChange={handleChange}  value={data.zipcode?data.zipcode:''} name="zipcode" type="text" className="form-control" placeholder={t('common.zipCode')} />
											{error && error.zipcode && <span className="required">{error.zipcode}</span>}
										</div>
									</div>
									<div className="col-lg-6 col-md-6">
										<div className=" form-group">
											<label>Registration Number </label>
											<input onChange={handleChange}  value={data.register_number?data.register_number:''} name="register_number" type="text" className="form-control" placeholder="Enter the Registration Number" />
										</div>
									</div>
								</div>								
								{/* Form Submit Section */}
								<div className="row mt-3">		
									<div className="col-lg-6 text-start">
										<Button
											variant={`btn btn-sm ${role === 4 ? 'btn-tmAquaDgreen' : 'btn-tmBlue'}`}
											className="ms-3"
											onClick={handlePrescriptionTemplateClick}
											>
											<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="me-2" style={ {marginBottom: '3px'}} viewBox="0 0 16 16">
												<path d="M9.243 1.828a1 1 0 0 0-2.486 0l-.28.853a5.982 5.982 0 0 0-1.003.582l-.857-.286a1 1 0 0 0-.95.316l-.707.707a1 1 0 0 0 .316.95l.286.857a5.982 5.982 0 0 0-.582 1.003l-.853.28a1 1 0 0 0 0 2.486l.853.28a5.982 5.982 0 0 0 .582 1.003l-.286.857a1 1 0 0 0 .316.95l.707.707a1 1 0 0 0 .95.316l.857-.286a5.982 5.982 0 0 0 1.003.582l.28.853a1 1 0 0 0 2.486 0l.28-.853a5.982 5.982 0 0 0 1.003-.582l.857.286a1 1 0 0 0 .95-.316l.707-.707a1 1 0 0 0-.316-.95l-.286-.857a5.982 5.982 0 0 0 .582-1.003l.853-.28a1 1 0 0 0 0-2.486l-.853-.28a5.982 5.982 0 0 0-.582-1.003l.286-.857a1 1 0 0 0-.316-.95l-.707-.707a1 1 0 0 0-.95-.316l-.857.286a5.982 5.982 0 0 0-1.003-.582l-.28-.853zM8 10a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"/>
											</svg>
											{t('modal.selectPrescriptionTemplate')}
										</Button>	
									</div>					
									<div className="col-lg-6 text-end">
										<button type="button" onClick={handleSubmit} className={`btn ${role === 4 ? 'btn-tmAquaGreen' : 'btn-tmBlue'} btnNext`}><i className="ri-arrow-right-line align-middle"></i> {t('profile.submit')}</button>
									</div>
								</div>
							</form>
							{/* End Form Section */}
						</div>								
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
{/* End Page Content Section */}
	
</main>
	);
};


export default AddPhysician;

